import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            component: () => import('./components/MainLayout'),
            children: [
                {
                    path: "",
                    name: "index",
                    component: () => import('./components/main/Landing')
                },
                {
                    path: "terms",
                    name: "terms",
                    component: () => import('./components/main/Terms')
                },
                {
                    path: "about",
                    name: "about",
                    component: () => import('./components/main/About')
                },
                {
                    path: "sales",
                    name: "sales",
                    component: () => import('./components/main/Sales')
                },
                {
                    path: "salesenquiry",
                    name: "salesenquiry",
                    component: () => import('./components/main/SalesContact')
                },
                {
                    path: "contact",
                    name: "contact",
                    component: () => import('./components/main/Contact')
                },
                {
                    path: "changelog",
                    name: "changelog",
                    component: () => import('./components/main/ChangeLog')
                },
                {
                    path: "docs",
                    name: "docs",
                    component: () => import('./components/main/Documentation')
                },
                {
                    path: "privacy",
                    name: "privacy",
                    component: () => import('./components/main/Privacy')
                },
                {
                    path: "products/:id",
                    name: "products",
                    props: true,
                    component: () => import('./components/main/Products')
                },
                {
                    path: "media",
                    component: () => import('./components/main/media/MediaLayout'),
                    children: [
                        {
                            path: "media",
                            name: "media",
                            component: () => import('./components/main/media/MediaHome')
                        },
                        {
                            path: "genesis-summit",
                            name: "genesis-summit",
                            component: () => import('./components/main/media/GenesisSummit')
                        },
                        {
                            path: "demo-truvito-wsf",
                            name: "demo-truvito-wsf",
                            component: () => import('./components/main/media/DemoTruvitoWsf')
                        },
                        {
                            path: "wsf-opening",
                            name: "wsf-opening",
                            component: () => import('./components/main/media/WsfOpening')
                        },
                        {
                            path: "summit-wsf",
                            name: "summit-wsf",
                            component: () => import('./components/main/media/BusinessSummitWsf')
                        }
                    ]
                },
            ]
        }
    ]
})
